import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FiCheck } from 'react-icons/fi';
import cn from 'classnames';
import { aclHelper } from 'helper';

import { useCreateModal } from 'partial/components/Modal';
import Status from '../modals/Status';

const statusData = [
  {
    id: 0,
    title: 'active',
    description: 'The user will be able to access the following portal.',
    isActive: 1,
  },
  {
    id: 1,
    title: 'deactivate',
    description:
      'Users will not be access the provider portal. The prompt message "Unable to Access. Please contact the System Administrator".',
    isActive: 0,
  },
];

const StatusButton = ({ userDetails }) => {
  const createModal = useCreateModal();
  const status = userDetails?.is_active;
  const canUpdate = aclHelper('user', 'u');

  const [isShown, setShown] = useState(false);

  const handleStatus = useCallback(() => {
    createModal({
      content: (onClose) => (
        <Status onClose={onClose} data={userDetails} setShown={setShown} />
      ),
    });
  }, [createModal, userDetails]);

  return (
    <div className="relative">
      <button
        className={cn(
          'flex gap-1 rounded-[4px] items-center border  capitalize font-semibold text-sm transition',
          status
            ? 'text-green-500 border-green-500 hover:bg-green-500 hover:text-white'
            : 'text-red-500 border-red-500 hover:bg-red-500 hover:text-white',
          canUpdate ? 'cursor-pointer' : 'cursor-default',
        )}
        type="button"
        onClick={() => (canUpdate ? setShown(!isShown) : {})}
      >
        <span className="px-2">
          <FiCheck />
        </span>
        <span className="mr-2">{status ? 'Active' : 'Inactive'}</span>
        <span
          className={cn(
            'px-2  text-white py-[10px]',
            status ? 'bg-green-500' : 'bg-red-500',
          )}
        >
          <FiCheck />
        </span>
      </button>
      {isShown && (
        <ul className="absolute -bottom-[14rem] drop-shadow-lg rounded right-0 z-10 bg-white ">
          {statusData?.map(({ id, title, description, isActive }) => (
            <li key={id}>
              <button
                type="button"
                onClick={() => handleStatus()}
                disabled={status === isActive}
                className={cn(
                  'p-3 w-[300px]  text-left',
                  isActive === status ? 'bg-gray-50' : 'hover:bg-gray-50/20',
                )}
              >
                <h5 className="capitalize font-semibold text-sm text-gray-700 mb-1 flex gap-1 items-center">
                  <span>{title}</span>
                  {userDetails?.status === title && (
                    <FiCheck className="text-green-500 text-sm" />
                  )}
                </h5>
                <p className="text-sm ">{description}</p>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

StatusButton.propTypes = {
  userDetails: PropTypes.instanceOf(Object).isRequired,
};

export default StatusButton;
